<div class="scorecards-container">
  <ng-container *ngIf="data?.length > 0; else noDataTemplate">
    <ion-card *ngFor="let stats of data">
      <ion-card-header>
        <div class="score-header score-header-title">
          <ion-card-title>{{ stats.title }}</ion-card-title>
          <ion-card-subtitle>{{this.agent2Scenario[stats.agentName].title}} / {{ stats.agentName }}</ion-card-subtitle>
        </div>
        <div class="score-header">
          <div class="score-container">
            <div class="label">
              <span>{{ userType === 'manager' ? '__CALLS_AVERAGE__' : '' | translate }} {{ "__CALLS_HIGHEST_SCORE__" | translate }}</span>
              <span class="sub-text">{{ "__CALLS_FROM_ONE_CALL__" | translate }}</span>
            </div>
            <ion-badge class="score" [style.background-color]="interpolateColor(stats.bestScore)">
              {{ stats.bestScore | number: '1.2-2' }}
            </ion-badge>
          </div>
          <div class="score-container">
            <div class="label">
              <span>{{ "__CALLS_PERFORMANCE_IMPROVEMENT__" | translate }}</span>
              <span class="sub-text">{{ "__CALLS_FIRST_VS_BEST__" | translate }}</span>
            </div>
            <ion-badge class="score improvement-badge">
              {{ stats.performanceImprovement | number: '1.2-2' }}
              <img src="assets/icon/trending.svg" class="score-icon" alt="Trending Up">
            </ion-badge>
          </div>
          <div class="score-container">
            <div class="label">
              <span>{{ "__CALLS_IMPROVEMENT__" | translate }}</span>
              <span class="sub-text">{{ "__CALLS_FIRST_VS_AVG__" | translate }}</span>
            </div>
            <ion-badge class="score improvement-badge">
              {{ stats.improvement | number: '1.2-2' }}
              <img src="assets/icon/trending.svg" class="score-icon" alt="Trending Up">
            </ion-badge>
          </div>
        </div>
      </ion-card-header>

      <ion-card-content>
        <div class="section" *ngFor="let criterion of stats.criteriaList">
          <div class="section-line"></div>
          <div class="section-title">{{ criterion.title }}</div>
          <div class="metrics">
            <div class="metric">
              <div class="label">
                <span>{{ userType === 'manager' ? '__CALLS_AVERAGE__' : '' | translate }} {{ "__CALLS_FIRST_ATTEMPT__" | translate }}</span>
              </div>
              <div class="value" [style.background-color]="interpolateColor(criterion.firstAttempt)">
                {{ criterion.firstAttempt | number: '1.2-2' }}
              </div>
            </div>
            <div class="metric">
              <div class="label">
                <span>{{ userType === 'manager' ? '__CALLS_AVERAGE__' : '' | translate }} {{ "__CALLS_BEST_ATTEMPT__" | translate }}</span>
              </div>
              <div class="value" [style.background-color]="interpolateColor(criterion.bestAttempt)">
                {{ criterion.bestAttempt | number: '1.2-2' }}
              </div>
            </div>
            <div class="metric">
              <div class="label">
                <span>{{ "__CALLS_AVG_SCORE__" | translate }}</span>
                <span class="sub-text">{{ "__CALLS_ACROSS_ALL_ATTEMPTS__" | translate }}</span>
              </div>
              <div class="value" [style.background-color]="interpolateColor(criterion.avgScore)">
                {{ criterion.avgScore | number: '1.2-2' }}
              </div>
            </div>
            <div class="metric">
              <div class="label">
                <span>{{ "__CALLS_PERFORMANCE_IMPROVEMENT__" | translate }}</span>
                <span class="sub-text">{{ "__CALLS_FIRST_VS_BEST__" | translate }}</span>
              </div>
              <div class="value improvement-badge">
                {{ criterion.performanceImprovement | number: '1.2-2' }}
                <img src="assets/icon/trending.svg" class="score-icon" alt="Trending Up">
              </div>
            </div>
            <div class="metric">
              <div class="label">
                <span>{{ "__CALLS_IMPROVEMENT__" | translate }}</span>
                <span class="sub-text">{{ "__CALLS_FIRST_VS_AVG__" | translate }}</span>
              </div>
              <div class="value improvement-badge">
                {{ criterion.improvement | number: '1.2-2' }}
                <img src="assets/icon/trending.svg" class="score-icon" alt="Trending Up">
              </div>
            </div>
          </div>
        </div>
      </ion-card-content>
    </ion-card>
  </ng-container>
  <ng-template #noDataTemplate>
    <div class="no-data-row">
        <span>{{ "__CALLS_DATA_IS_EMPTY__" | translate }}</span>
    </div>
  </ng-template>
</div>
